// @flow

import { connect } from "react-redux";
import React, { useEffect } from "react";
import * as R from "ramda";
import { Portal } from "@chakra-ui/react";
import type { Map as ImmutableMap } from "immutable";
import { getSelectedChecklist, getWorkflowSelectedRows } from "src/reducers";
import Field from "src/components/Manage/Workflow/Instances/ChecklistField";

import { closeChecklistManageView } from "src/actions/checklist";
import {
  getChecklistFieldDetails,
  getConversationModalVisibility,
} from "src/reducers";
import { Modal, Overlay } from "./styles";
import OutsideClickHandler from "src/components/OutsideClickHandler";

import type { AppState, SelectedChecklist } from "src/types";

type Props = {
  details: ImmutableMap<string, any>,
  selectedChecklist: SelectedChecklist,
  _closeChecklistManageView: Function,
  isBulkUpdate: boolean,
  isConversationModalOpen: boolean,
  isParent: boolean,
  closePortal: Function,
};

const EditChecklistModal = ({
  details,
  selectedChecklist,
  isBulkUpdate,
  isConversationModalOpen,
  closePortal,
  isParent,
}: Props) => {
  const { fieldId, value, roomId, columnId } = selectedChecklist;
  const type = details ? details.get("type") : "";

  const handleOutsideClick = (e) => {
    if (e.target.id === "edit-overlay") closePortal();
  };

  // Close the edit field modal if conversation modal is opened
  useEffect(() => {
    if (isConversationModalOpen) {
      closePortal();
    }
  }, [isConversationModalOpen]);

  useEffect(() => {
    // Handle bulk update of form without the modal
    if (R.isEmpty(selectedChecklist) || (type === "form" && isBulkUpdate)) {
      closePortal();
    }
  }, [selectedChecklist, type]);

  if (R.isEmpty(selectedChecklist)) {
    return <></>;
  }

  const isConversation = ["conversation", "childConversation", "link"].includes(
    type,
  );

  return (
    <Portal>
      <Overlay id="edit-overlay">
        <OutsideClickHandler onClickOutside={handleOutsideClick}>
          <Modal isParent={isParent} isConversation={isConversation}>
            <Field
              id={fieldId}
              roomId={`${roomId}`}
              columnId={columnId}
              type={type}
              selectedValue={value}
              handleClose={closePortal}
              fromManageView
            />
          </Modal>
        </OutsideClickHandler>
      </Overlay>
    </Portal>
  );
};

const mapStateToProps = ({ app }: { app: AppState }) => {
  const selectedChecklist = getSelectedChecklist(app);
  const selectedRows = getWorkflowSelectedRows(app) || [];
  const isBulkUpdate = selectedRows.length > 1;
  return {
    selectedChecklist,
    isBulkUpdate,
    details: getChecklistFieldDetails(app, `${selectedChecklist.fieldId}`),
    isConversationModalOpen: getConversationModalVisibility(app),
  };
};

export default connect(mapStateToProps, {
  _closeChecklistManageView: closeChecklistManageView,
})(EditChecklistModal);
